export const chartData = [
    {
      name: 'Jan',
      credit: 7000,
      debit: 3500,
      amt: 2400,
    },
    {
      name: 'Feb',
      credit: 3000,
      debit: 1398,
      amt: 2210,
    },
    {
      name: 'March',
      credit: 4000,
      debit: 5800,
      amt: 2290,
    },
    {
      name: 'April',
      credit: 2780,
      debit: 3908,
      amt: 2000,
    },
    {
      name: 'May',
      credit: 5890,
      debit: 4800,
      amt: 2181,
    },
    {
      name: 'June',
      credit: 2390,
      debit: 3800,
      amt: 2500,
    },
    {
      name: 'July',
      credit: 3490,
      debit: 4300,
      amt: 2100,
    },
];